import AppCard from '@nxsys/components/AppCard';
import AppIconCard from '@nxsys/components/AppIconCard';
import {
  useGetStatisticsPensionContribution,
  useGetStatisticsPensionSubcontractors,
} from '@nxsys/hooks/api/dashboard';
import { Icons } from '@nxsys/types/icons';
import { useEffect, useMemo, useState } from 'react';
import PensionSubmissionErrorModal from './components/PensionSubmissionErrorModal';
import EnrollmentErrorModal from './components/EnrollmentErrorModal';
import { PAYMENT_MODEL_ENUM } from '@nxsys/constants/AppEnums';
import { Col, Row } from 'antd';
import { defaultTheme } from '@nxsys/constants/defaultConfig';
import PendingPensionSubmissionModal from './components/PendingPensionSubmissionModal';
import AllPensionModal from './components/AllPensionModal';
import EmployeeModal, {
  EmployeeModalTypeEnum,
} from './components/EmployeeModal';

const PensionContributionBureau = () => {
  const {
    value: dataPensionContributionValue,
    loading: loadingPensionContribution,
    run: runPensionContribution,
  } = useGetStatisticsPensionContribution();
  const dataPensionContribution = useMemo(
    () => dataPensionContributionValue?.data,
    [dataPensionContributionValue],
  );

  const {
    value: dataPensionSubcontractorsValue,
    loading: loadingPensionSubcontractors,
    run: runPensionSubcontractors,
  } = useGetStatisticsPensionSubcontractors();
  const dataPensionSubcontractors = useMemo(
    () => dataPensionSubcontractorsValue?.data,
    [dataPensionSubcontractorsValue],
  );
  const [isOpenSubmissionErrorModal, setIsOpenSubmissionErrorModal] =
    useState(false);

  const [isOpenEnrollmentErrorModal, setIsOpenEnrollmentErrorModal] =
    useState(false);

  const [isOpenAllPensionModal, setIsOpenAllPensionModal] = useState(false);

  const [isOpenPensionOptOutModal, setIsOpenPensionOptOutModal] =
    useState(false);

  const [
    isOpenPendingPensionSubmissionModal,
    setIsOpenPendingPensionSubmissionModal,
  ] = useState(false);

  useEffect(() => {
    runPensionContribution({ paymentModels: [PAYMENT_MODEL_ENUM.PAYEE] });
    runPensionSubcontractors();
  }, []);

  const cbAfterAction = () => {
    runPensionContribution({ paymentModels: [PAYMENT_MODEL_ENUM.PAYEE] });
    runPensionSubcontractors();
  };

  const items = [
    {
      title: dataPensionContribution?.totalErrorPension,
      description: 'Submission Errors',
      onClick: () => setIsOpenSubmissionErrorModal(true),
    },
    {
      title: dataPensionSubcontractors?.totalErrorSmartPensionEnrollments,
      description: 'Enrollment Errors',
      onClick: () => setIsOpenEnrollmentErrorModal(true),
    },
  ];

  return (
    <div className="OnHold h-full">
      <AppCard
        className="p-[24px] h-full"
        loading={loadingPensionContribution || loadingPensionSubcontractors}
      >
        <div className="flex justify-between items-center mb-[24px] max-sm:!block">
          <AppIconCard
            iconName="IconHandHoldingDollar"
            title="Pension Contribution"
          />
          <div className="flex items-center gap-x-[12px] max-sm:mt-[16px]">
            <div className="w-[38px] h-[38px] bg-[#FDF1F0] rounded-full p-[6px]">
              <Icons.IconChairMoney />
            </div>
            <div className="text-[14px] font-[500]">
              <span className="text-gray-500">You have</span>{' '}
              <span
                className="text-primary-600 cursor-pointer underline"
                onClick={() => setIsOpenPensionOptOutModal(true)}
              >
                {dataPensionContribution?.pensionOptOut ?? 0} Opt-Out in the
                last 30 days.
              </span>
              <span
                className="text-primary-600 cursor-pointer ml-1"
                onClick={() => setIsOpenAllPensionModal(true)}
              >
                See all pension
              </span>
            </div>
          </div>
        </div>
        <Row gutter={[16, 16]}>
          <Col sm={24} md={12}>
            <div
              className="border border-[#CDDDD9] dashboard-hover-card rounded-[8px] p-[16px]"
              onClick={() => setIsOpenPendingPensionSubmissionModal(true)}
            >
              <div className="flex items-center justify-between gap-x-[8px] mb-[18px]">
                <div className="bg-violet-100 rounded-[8px] p-[8px]">
                  <Icons.IconClock
                    color={defaultTheme.theme.palette.violet[500]}
                  />
                </div>
                <Icons.IconArrowRight />
              </div>
              <div className="text-[22px] font-bold mb-[8px]">
                {dataPensionContribution?.totalPendingSubmitPension}
              </div>
              <div className="text-[14px] font-bold">Pending Submissions</div>
            </div>
          </Col>
          <Col sm={24} md={12}>
            <div className="space-y-[16px]">
              {items.map((item) => (
                <div
                  key={item.title}
                  className="border border-[#CDDDD9] dashboard-hover-card rounded-[8px] p-[16px] flex items-center w-full gap-x-[12px]"
                  onClick={item.onClick}
                >
                  <div className="border-[3px] border-error-300 rounded-full w-[12px] h-[12px]"></div>
                  <div className="flex gap-x-[8px] flex-1 items-center">
                    <div className="text-[22px] font-bold">{item.title}</div>
                    <div className="text-[14px] font-bold">
                      {item.description}
                    </div>
                  </div>
                  <Icons.IconArrowRight />
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </AppCard>
      <PensionSubmissionErrorModal
        isOpen={isOpenSubmissionErrorModal}
        toggle={() => setIsOpenSubmissionErrorModal(false)}
        cbAfterAction={cbAfterAction}
      />
      <EnrollmentErrorModal
        isOpen={isOpenEnrollmentErrorModal}
        toggle={() => setIsOpenEnrollmentErrorModal(false)}
      />
      <PendingPensionSubmissionModal
        isOpen={isOpenPendingPensionSubmissionModal}
        toggle={() => setIsOpenPendingPensionSubmissionModal(false)}
        cbAfterAction={cbAfterAction}
      />
      <AllPensionModal
        isOpen={isOpenAllPensionModal}
        toggle={() => setIsOpenAllPensionModal(false)}
      />
      <EmployeeModal
        isOpen={isOpenPensionOptOutModal}
        toggle={() => setIsOpenPensionOptOutModal(false)}
        type={EmployeeModalTypeEnum.PENSION_OPT_OUT}
      />
    </div>
  );
};

export default PensionContributionBureau;
